import type { ComputedRef } from 'vue';
import type { DxDataGrid } from 'devextreme-vue/data-grid';
import type { InputType } from '~/types';

type DxInstance = NonNullable<InstanceType<typeof DxDataGrid>['instance']>;

export interface UseDataGridSearchOptions {
  dataGrid: ComputedRef<DxInstance | undefined>;
}

export const useDataGridSearch = ({ dataGrid }: UseDataGridSearchOptions) => {
  const { isGlobalSearch } = storeToRefs(useStore());
  let timeout: NodeJS.Timeout;

  const handleSearchValue = (
    valueToSearch: InputType,
    isAccountList?: boolean,
    emitCallback?: (value: string) => void
  ) => {
    isGlobalSearch.value = true;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (isAccountList) {
        if (emitCallback) emitCallback(valueToSearch.value ?? '');
        return;
      }
      const value = valueToSearch.value ?? '';
      dataGrid.value?.searchByText(value);
    }, 1000);
  };

  return { handleSearchValue };
};
